import React from "react";
import DentalObservation from "../../../project-details/single-case-result-details/child/dental-observation/DentalObservation";
import { useSelector } from "react-redux";

const ObservationList = ({ data, onEdit }) => {
  const markedTeeth = useSelector((state) => state.dental?.markedTeeth || []);
  const quadrantData = useSelector((state) => state.dental?.quadrants || []);

  // Filter both arrays to get items with a non-empty observation
  const markedTeethWithObservation = markedTeeth.filter(
    (el) => el.observation && el.observation.trim() !== ""
  );
  const quadrantDataWithObservation = quadrantData.filter(
    (el) => el.observation && el.observation.trim() !== ""
  );

  // Combine both arrays into a single array

  return (
    <div className="d_observation_list_container">
      {markedTeethWithObservation?.map((item, index) => {
        return (
          <div className="d_observation_list_item" key={index}>
            <p className="heading">Teeth</p>

            <DentalObservation
              key={index}
              item={item}
              isDirty={true}
              onEdit={() => onEdit(item, "tooth")}
              type={"teeth"}
            />
          </div>
        );
      })}
      {quadrantDataWithObservation?.map((item, index) => {
        return (
          <div className="d_observation_list_item" key={index}>
            <p className="heading">Quadrants</p>
            <DentalObservation
              key={index}
              item={item}
              isDirty={true}
              onEdit={() => onEdit(item, "quadrant")}
              type={"quadrant"}
            />
          </div>
        );
      })}
    </div>
  );
};

export default ObservationList;
